import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PortalRoutes from "./auth/PortalRoutes";
import "./portal.css";

const PortalAppRoot = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/portal/:subdomain/*" element={<PortalRoutes />} />
      </Routes>
    </BrowserRouter>
  );
};

export default PortalAppRoot;
